var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-gifts page--padding"},[_c('special-gifts-intro'),_c('special-gifts-trust-us'),_c('special-gifts-solutions'),_c('special-gifts-contacts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }